import { ArticleType, OldArticleType } from '@/data/api/content/content.type';
import { getStrapiUrl } from './strapi.utils';
import { StrapiAsset } from '../types/utils.type';

export const getImageUrlFromArticle = (article: {
  image?: StrapiAsset;
  articleImage?: StrapiAsset;
}) => {
  return (
    (article.articleImage != null || article.image != null
      ? getStrapiUrl(article.articleImage || (article.image as StrapiAsset))
      : null) || '/images/laptop.png'
  );
};

export const getRedirectUrlOfArticle = (
  article: Pick<ArticleType, 'category' | 'content' | 'slug'>
) => {
  return (article as OldArticleType).content == null
    ? `/blog/${article?.category?.slug}/${article.slug}`
    : `/blogs/${article?.category?.slug}/${article.slug.split('_')[1] || ''}`;
};
